import React from 'react';
import globalMessages from 'translations/messages';
import { FormattedMessage } from 'react-intl';
import Surveys from './Surveys';
import SurveyTranslations from './SurveyTranslations';
import FlaggedComments from './FlaggedComments';
import Users from './Users';
import Roles from './Roles';
import Licenses from './Licenses';
import SurveyCategories from './SurveyCategories';
import GlobalSettings from './GlobalSettings';
import messages from './messages';
import DataSources from './DataSources';
import Orders from './Orders';
import DataSourceLicenses from './DataSourceLicenses';
import ModulesLicenses from './ModuleLicenses';
import DataTools from './DataTools';
import Customers from './Customers';
import AutoTaggings from './AutoTaggings';
import PipedriveSettings from './PipedriveSettings';
import EmailTemplateSettings from './EmailTemplateSettings';
import AiPromptSettings from './AiPromptSettings';
import PiiScanSettings from './PiiScanSettings';
import Coupons from './Coupons';
import PredefinedSegments from '../Tools/Segments/PredefinedSegments';
import ApiKeys from './ApiKeys';

const routes = [
  {
    path: 'customers',
    component: Customers,
    label: <FormattedMessage {...globalMessages.customers} />,
  },
  {
    path: 'data-sources',
    component: DataSources,
    label: <FormattedMessage {...globalMessages.dataSources} />,
  },
  {
    path: 'data-source-licenses',
    component: DataSourceLicenses,
    label: <FormattedMessage {...messages.dataSourceLicenses} />,
  },
  {
    path: 'surveys',
    component: Surveys,
    label: <FormattedMessage {...globalMessages.surveys} />,
  },
  {
    path: 'users',
    component: Users,
    label: <FormattedMessage {...globalMessages.users} />,
  },
  {
    path: 'roles',
    component: Roles,
    label: <FormattedMessage {...messages.authRoles} />,
  },
  {
    path: 'licenses',
    component: Licenses,
    label: 'Legacy products',
  },
  {
    path: 'module-licenses',
    component: ModulesLicenses,
    label: <FormattedMessage {...globalMessages.modules} />,
  },
  {
    path: 'survey-translations',
    component: SurveyTranslations,
    label: <FormattedMessage {...messages.surveyTranslations} />,
  },
  {
    path: 'survey-categories',
    component: SurveyCategories,
    label: <FormattedMessage {...globalMessages.industries} />,
  },
  {
    path: 'global-settings',
    component: GlobalSettings,
    label: 'Global settings',
  },
  {
    path: 'pipedrive-settings',
    component: PipedriveSettings,
    label: 'Pipedrive settings',
  },
  {
    path: 'email-template-settings',
    component: EmailTemplateSettings,
    label: 'Email template settings',
  },
  {
    path: 'ai-prompt-settings',
    component: AiPromptSettings,
    label: 'AI settings',
  },
  {
    path: 'pii-scan-settings',
    component: PiiScanSettings,
    label: 'PII scan settings',
  },
  {
    path: 'flagged-comments',
    component: FlaggedComments,
    label: <FormattedMessage {...globalMessages.flaggedComments} />,
  },
  {
    path: 'orders',
    component: Orders,
    label: 'Orders',
  },
  {
    path: 'data-tools',
    component: DataTools,
    label: 'Data Tools',
  },
  {
    path: 'auto-taggings',
    component: AutoTaggings,
    label: 'AI Tagging',
  },
  {
    path: 'coupons',
    component: Coupons,
    label: <FormattedMessage {...messages.coupons} />,
  },
  {
    path: 'predefined-segments',
    component: PredefinedSegments,
    label: 'Predefined Segments',
  },
  {
    path: 'api-keys',
    component: ApiKeys,
    label: <FormattedMessage {...messages.apiKeys} />,
  },
];

export default routes;
